import { PasswordInput as MPasswordInput } from '@mantine/core';
import classes from './passwordInput.module.scss';

export const PasswordInput = MPasswordInput.extend({
  classNames: classes,
});
